import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePackageExtraMutationVariables = GraphQLTypes.Exact<{
  packageId: GraphQLTypes.Scalars['String'];
  id: GraphQLTypes.Scalars['String'];
  packageExtraInput: GraphQLTypes.UpdateExtraPackageInput;
}>;


export type UpdatePackageExtraMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'updatePackageExtra'>
);


export const UpdatePackageExtraDocument = /*#__PURE__*/ gql`
    mutation updatePackageExtra($packageId: String!, $id: String!, $packageExtraInput: UpdateExtraPackageInput!) {
  updatePackageExtra(
    packageId: $packageId
    id: $id
    packageExtraInput: $packageExtraInput
  )
}
    `;

/**
 * __useUpdatePackageExtraMutation__
 *
 * To run a mutation, you first call `useUpdatePackageExtraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageExtraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageExtraMutation, { data, loading, error }] = useUpdatePackageExtraMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      id: // value for 'id'
 *      packageExtraInput: // value for 'packageExtraInput'
 *   },
 * });
 */
export function useUpdatePackageExtraMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackageExtraMutationResult, UpdatePackageExtraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackageExtraMutationResult, UpdatePackageExtraMutationVariables>(UpdatePackageExtraDocument, options);
      }
export type UpdatePackageExtraMutationHookResult = ReturnType<typeof useUpdatePackageExtraMutation>;